var map = {
	"./template.betgalaxy": 2061,
	"./template.betgalaxy.tsx": 2061,
	"./template.betprofessor": 1144,
	"./template.betprofessor.tsx": 1144,
	"./template.betroyale": 1145,
	"./template.betroyale.tsx": 1145,
	"./template.default": 661,
	"./template.default.tsx": 661,
	"./template.fiestabet": 1146,
	"./template.fiestabet.tsx": 1146,
	"./template.puntcity": 1147,
	"./template.puntcity.tsx": 1147,
	"./template.puntgenie": 1148,
	"./template.puntgenie.tsx": 1148,
	"./template.questbet": 1149,
	"./template.questbet.tsx": 1149,
	"./template.ts": 972,
	"./template.volcanobet": 1150,
	"./template.volcanobet.tsx": 1150,
	"./template.wellbet": 1151,
	"./template.wellbet.tsx": 1151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2432;